module.exports = __webpack_public_path__ + "static/BrainTalk_WithBrain-f08e67344261a406343f0fdac6740a39.png";